<template>
  <div class="repairTrace-container repairPage-container">
    <div class="repairTrace-header" v-if="currentToken">
      <div></div>
      <el-button
        type="text"
        icon="el-icon-user-solid"
        @click="clearStorage"
        class="repairTrace-logou"
        >退出当前手机号</el-button
      >
    </div>
    <div class="repairTrace-form" v-else>
      <div class="repairTrace-code-handle-btn">
        <el-input
          v-model.trim="phone"
          oninput="value=value.replace(/[^\d]/g,'')"
          class="repairTrace-text-input"
          :placeholder="$t('placeholder.phone')"
          @keyup.enter.native="checkDetails"
          clearable
        ></el-input>
      </div>
      <div class="repairTrace-code-handle-btn">
        <el-input
          v-model.trim="code"
          ref="codeInput"
          oninput="value=value.replace(/[^\d]/g,'')"
          class="repairTrace-text-input"
          :placeholder="$t('placeholder.code')"
          @keyup.enter.native="checkDetails"
          clearable
        ></el-input>
        <el-button
          v-if="!isGetCode"
          class="gb-button code-btn"
          @click="getCode"
          >{{ $t("login.getCode") }}</el-button
        >
        <el-button v-else class="gb-button code-btn gb-button-disabled" disabled
          >{{ $t("common.resend") }}（{{ countdown }}）</el-button
        >
      </div>
      <el-button
        class="repairTrace-form-btn white-color gb-button font-format-normal multiple-family"
        @click="checkDetails"
        >{{ $t("login.login") }}</el-button
      >
      <div class="repairTrace-oldData-tips">
        <p class="font-format-medium medium-family">
          因系统更新，2022年8月16日19:00前提交的数据请点击以下地址进行查询
        </p>
        （<a
          class="font-format-medium medium-family"
          href="https://send2boox.com/o/d/"
          target="_blank"
          >https://send2boox.com/o/d/</a
        >）
      </div>
    </div>
    <div class="repairTrace-main" v-if="currentToken">
      <div class="repairTrace-main-card" v-if="orders && orders.length">
        <div class="repairTrace-toolbar">
          <el-button type="primary" @click="openTicket">开票</el-button>
        </div>
        <el-table
          ref="orderTable"
          :data="orders"
          row-key="id"
          height="100%"
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column label="维修编号" show-overflow-tooltip>
            <template slot-scope="scope">
              <span>{{
                (scope.row.billDetail &&
                  scope.row.billDetail.repair &&
                  scope.row.billDetail.repair.code) ||
                  scope.row.code
              }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="型号"
            prop="deviceModel"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <span>{{
                scope.row.details.map((item) => item.model).join("/")
              }}</span>
            </template>
          </el-table-column>

          <el-table-column label="进度" prop="step" show-overflow-tooltip>
            <template slot-scope="scope">
              <span>{{ formatStepTitle(scope.row.status) }}</span>
            </template>
          </el-table-column>
          <el-table-column label="开票状态" show-overflow-tooltip>
            <template slot-scope="scope">
              <span>{{
                scope.row.billDetail &&
                scope.row.billDetail.repair &&
                scope.row.billDetail.repair.invoiceSerialNo
                  ? "已开票"
                  : "未开票"
              }}</span>
            </template>
          </el-table-column>
          <el-table-column label="时间" prop="createdAt" show-overflow-tooltip>
          </el-table-column>
        </el-table>
      </div>
      <div class="repairTrace-noData" v-else>
        <img src="@/assets/imgs/icon_table_no_gift.svg" alt="" />
        <p class="table-empty-msg font-format-medium regular-family">
          暂无数据
        </p>
        <div class="repairTrace-oldData-tips">
          <p class="font-format-medium medium-family">
            因系统更新，2022年8月16日19:00前提交的数据请点击以下地址进行查询
          </p>
          （<a href="https://send2boox.com/o/d/" target="_blank"
            >https://send2boox.com/o/d/</a
          >）
        </div>
      </div>
    </div>

    <!-- 开票弹窗 -->
    <InvoiceDialog
      :visible.sync="invoiceDialogVisible"
      :order-item="currentOrderItem"
      @confirm="handleInvoiceConfirm"
    />
  </div>
</template>

<script>
import { formatDate } from "@/utils/filters";
import InvoiceDialog from "./components/InvoiceDialog.vue";
export default {
  components: {
    InvoiceDialog,
  },
  data() {
    return {
      phone: "",
      code: "",
      areaCode: "86",
      countdown: 60,
      isGetCode: false,
      initTime: null,
      orders: [],
      keyCode: null,
      currentToken: "",
      invoiceDialogVisible: false,
      currentOrderItem: null,
      selectedOrders: [],
    };
  },
  methods: {
    handleSelectionChange(selection) {
      this.selectedOrders = selection;
    },
    async openTicket() {
      if (this.selectedOrders.length === 0) {
        this.elMsg("请至少选择一条记录", "warning");
        return;
      }
      // 检查所有选中项的开票状态
      const checkResult = await this.checkTicketStatus();
      if (!checkResult) {
        return; // 用户取消或全部已开票
      }
      // 使用第一个选中项作为主订单信息，合并所有选中项的details
      this.currentOrderItem = {
        ...this.selectedOrders[0],
        // 合并所有选中项的details
        details: this.selectedOrders.reduce((acc, order) => {
          if (order.billDetail) {
            acc = acc.concat([order.billDetail]);
          }
          return acc;
        }, []),
      };
      this.invoiceDialogVisible = true;
    },
    async checkTicketStatus() {
      // 检查所有选中项的开票状态，使用列表内的开票状态判断
      const invoicedOrders = this.selectedOrders.filter(
        (order) => order.billDetail?.repair?.invoiceSerialNo
      );
      const uninvoicedOrders = this.selectedOrders.filter(
        (order) => !order.billDetail?.repair?.invoiceSerialNo
      );

      // 情况1: 全部已开票
      if (invoicedOrders.length === this.selectedOrders.length) {
        this.elMsg("选中项均已开票", "warning");
        this.selectedOrders = [];
        return false;
      }

      // 情况2: 全部未开票，直接继续
      if (invoicedOrders.length === 0) {
        return true;
      }

      // 情况3: 部分已开票，弹窗提示
      const invoicedCodes = invoicedOrders
        .map((o) => o.billDetail?.repair?.code || o.code)
        .join("、");
      try {
        await this.$confirm(
          `单号${invoicedCodes}已开票，是否为其余单号开票？`,
          "提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }
        );
        // 用户点击确定，移除已开票的订单
        this.selectedOrders = uninvoicedOrders;
        // 更新表格选中状态
        this.$nextTick(() => {
          if (this.$refs.orderTable) {
            this.$refs.orderTable.clearSelection();
            uninvoicedOrders.forEach((order) => {
              const row = this.orders.find((o) => o.id === order.id);
              if (row) {
                this.$refs.orderTable.toggleRowSelection(row, true);
              }
            });
          }
        });
        return true;
      } catch {
        // 用户点击取消
        return false;
      }
    },
    handleInvoiceConfirm(formData) {
      const promiselist = [];
      this.selectedOrders.forEach((order) => {
        const params = {
          taxNo: "91440103683265947B",
          invoiceTerminalCode: "13535056057",
          orderNo: order.billDetail?.repair?.code,
          orderDateTime: formatDate(new Date()),
          buyerTaxNo: formData.buyerTaxNo || "",
          buyerName: formData.buyerName || "",
          buyerAddress: "",
          buyerTelphone: formData.buyerTelphone,
          buyerBankName: formData.buyerBankName || "",
          buyerBankNumber: formData.buyerBankNumber || "",
          invoiceType: "1",
          invoiceTypeCode: formData.invoiceTypeCode || "02",
          naturalMark: formData.naturalMark,
          invoiceDetailList: [
            {
              goodsName: "维修费",
              goodsSpecification: order.billDetail.model || "",
              goodsTotalPrice: order.billDetail.repair?.bill?.amount || "0",
              // goodsTotalPrice: "1.00",
              goodsQuantity: "1",
              goodsTaxRate: "0.13",
              goodsPrice: order.billDetail.repair?.bill?.amount || "0",
              // goodsPrice: "1.00",
            },
          ],
          remarks: formData.remarks || "",
          pushPhone: formData.buyerTelphone,
          pushEmail: formData.pushEmail || "",
          priceTaxMark: "1",
        };
        promiselist.push(this.$http.getTicket(params));
      });
      Promise.all(promiselist)
        .then((res) => {
          if (res.some((item) => item.data?.errorResponse?.message)) {
            const item = res.find((item) => item.data?.errorResponse?.message);
            const errorMessage = item?.data?.errorResponse?.message;
            const subMessage = item?.data?.errorResponse?.subMessage;
            this.elMsg(errorMessage + "：" + subMessage, "error");
            return;
          }
          this.elMsg("开票成功", "success");
          this.selectedOrders = [];
          this.getRepairReqList();
        })
        .catch((error) => {
          console.error(error);
          this.elMsg("开票失败", "error");
        });
    },
    formatStepTitle(status) {
      let title = "";
      switch (status) {
        case 0:
          title = `待签收`;
          break;
        case 1:
          title = `处理中`;
          break;
        case 2:
          title = `待付费`;
          break;
        case 3:
          title = `文石寄出`;
          break;
      }
      return title;
    },
    async getCode() {
      if (!this.checkPhoneParams()) return;
      this.countdownStart();
      this.isGetCode = true;
      let params = {
        phone: this.phone,
      };
      try {
        await this.$http.newSendMobileCode(params);
      } catch (error) {
        clearInterval(this.initTime);
        this.isGetCode = false;
        this.countdown = 60;
      }
    },

    countdownStart() {
      clearInterval(this.initTime);
      this.initTime = setInterval(() => {
        if (this.countdown === 1) {
          this.isGetCode = false;
          this.countdown = 60;
          clearInterval(this.initTime);
        } else {
          this.countdown -= 1;
        }
      }, 1000);
    },

    checkPhoneParams() {
      if (!this.phone || this.phone.indexOf(" ") !== -1) {
        this.elMsg(this.$t("elMsg.phoneEmpty"), "error");
        return false;
      }

      if (!this.areaCode || this.areaCode.indexOf(" ") !== -1) {
        this.elMsg(this.$t("elMsg.areaEmpty"), "error");
        return false;
      }

      return true;
    },

    checkCode() {
      this.code = this.$refs.codeInput.getInput().value;
      if (!this.code || this.code.indexOf(" ") !== -1) {
        this.elMsg(this.$t("elMsg.codeEmpty"), "error");
        return false;
      }
      return true;
    },

    async checkDetails() {
      if (!this.checkPhoneParams() || !this.checkCode()) return;
      try {
        await this.login();
        await this.getRepairReqList();
        this.elMsg(this.$t("elMsg.checkSuccess"), "success");
        this.code = "";
        this.phone = "";
        this.countdown = 60;
        this.isGetCode = false;
      } catch (error) {
        console.log(error);
      }
    },

    async login() {
      return new Promise(async (resolve, reject) => {
        let params = {
          phone: this.phone,
          code: this.code,
        };
        try {
          let res = await this.$http.suserLogin(params);
          this.$local.set("afterSaleToken", res.data);
          this.$cookie.set("afterSaleToken", res.data);
          this.currentToken = res.data;
          resolve("ok");
        } catch (error) {
          reject(error);
        }
      });
    },

    getRepairReqList() {
      return new Promise(async (resolve, reject) => {
        try {
          let res = await this.$http.getRepairReqList({ code: this.keyCode });
          if (!res.data.length) {
            this.elMsg("暂无数据", "warning");
            return;
          }
          let order = [];
          res.data.forEach((item) => {
            if (item.details?.length) {
              item.details?.forEach((detail) => {
                if (+detail.repair?.bill?.amount) {
                  order.push({
                    ...item,
                    billDetail: detail,
                  });
                }
              });
            }
          });
          order.sort(
            (a, b) =>
              new Date(b.createdAt || 0).getTime() -
              new Date(a.createdAt || 0).getTime()
          );
          this.orders = order;
          resolve("ok");
        } catch (error) {
          if (error.code === 11001) {
            this.clearStorage();
          }
          reject(error);
        }
      });
    },

    clearStorage() {
      this.$local.remove("afterSaleToken");
      this.$local.remove("oId");
      this.$cookie.remove("afterSaleToken");
      this.currentToken = "";
      this.orders = [];
    },
  },
  mounted() {
    // this.keyCode = this.$route.query.s ? this.$route.query.s : null;
    this.currentToken = this.$local.get("afterSaleToken");
    if (this.currentToken) {
      this.getRepairReqList();
    }
  },
};
</script>

<style lang="scss">
.repairTrace-container {
  flex: 1;
  background: #fff;
  .repairTrace-header {
    padding: 0 10px;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #eee;
    > .repairTrace-logou {
      font-size: 16px;
    }
  }
  .repairTrace-form {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-bottom: 20px;
    border-bottom: 1px solid #eee;
    overflow: hidden;
    .repairTrace-code-handle-btn + .repairTrace-code-handle-btn {
      margin-top: 20px;
    }
    .repairTrace-code-handle-btn {
      display: flex;
      width: 100%;
      max-width: 350px;
      min-width: 150px;
      overflow: hidden;
      /* border: 1px solid #eeeeee; */
      background: $mainColor;
      border-radius: $button-radius;
      height: 38px;
      line-height: 38px;
      > .el-button {
        border: 0 !important;
      }
      .repairTrace-text-input {
        > .el-input__inner {
          background: transparent !important;
          padding: 0 10px 0 15px;
          border: 0;
        }
      }
      .code-btn {
        height: 100%;
        background: $themeColor;
        border-radius: $button-radius;
        box-shadow: none;
        color: #fff;
      }
    }

    .repairTrace-form-btn {
      width: 100%;
      max-width: 350px;
      min-width: 150px;
      margin-top: 20px;
    }
  }
  .repairTrace-oldData-tips {
    text-align: center;
    margin-top: 20px;
    > p {
      color: red;
    }
    > a {
      color: red;
      text-decoration: underline;
      &:hover {
        color: $delBtnColor;
      }
    }
  }
  .repairTrace-main {
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    .repairTrace-noData {
      height: 100% !important;
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      height: 220px;
      background: #fff;
      box-shadow: $div-shadow;
      border-radius: $button-radius;
      margin-top: 20px;

      > .table-empty-msg {
        margin-top: 15px;
        color: #595959;
      }
    }
    .repairTrace-main-card {
      flex: 1;
      display: flex;
      flex-direction: column;
      overflow: hidden;
      background: #fff;
      box-shadow: $div-shadow;
      border-radius: 4px;
      margin-top: 20px;
      .repairTrace-toolbar {
        padding: 10px;
        border-bottom: 1px solid #eee;
        text-align: right;
      }
    }
  }
}
</style>
